
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Location_$reflection } from "../../Shared/Location.js";
import { union_type, class_type, record_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { AccountSettings_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";

export class State extends Record {
    constructor(Locations, AccountSettings) {
        super();
        this.Locations = Locations;
        this.AccountSettings = AccountSettings;
    }
}

export function State_$reflection() {
    return record_type("Location.Overview.Types.State", [], State, () => [["Locations", RequestedValue$1_$reflection(list_type(Location_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LocationsFetched", "AccountSettingsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Location.Overview.Types.Msg", [], Msg, () => [[["Item", list_type(Location_$reflection())]], [["Item", AccountSettings_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

